module.exports = __webpack_public_path__ + "img/l_dk.d45953c0.png";